import { ProductFamiliesThemeSizeConfig } from './types';

const large: ProductFamiliesThemeSizeConfig = {
  productFamilies: {},
};

export default large;
